import React from "react";

function AgentDashboardPage() {
	const [selectedReminder, setSelectedReminder] = React.useState(null);
	const [isSendingReminder, setIsSendingReminder] = React.useState(false);
	const [isSendingEmailReminder, setIsSendingEmailReminder] =
		React.useState(false);
	const [reminderFeedback, setReminderFeedback] = React.useState("");

	const summaryCards = [
		{
			label: "Active leads",
			value: "148",
			note: "+18 in your pipeline this week",
			accent: "from-peach to-coral",
			progress: "74%",
		},
		{
			label: "Quotes shared",
			value: "96",
			note: "31 waiting for your follow-up",
			accent: "from-sky to-mint",
			progress: "64%",
		},
		{
			label: "Policies sold",
			value: "42",
			note: "88% of your monthly target",
			accent: "from-amber to-peach",
			progress: "88%",
		},
		{
			label: "Renewals due",
			value: "27",
			note: "9 need your urgent action",
			accent: "from-mint to-sky",
			progress: "41%",
		},
	];

	const funnelSteps = [
		{
			label: "Fresh enquiries",
			count: 52,
			width: "100%",
			tone: "from-peach to-coral",
		},
		{
			label: "Documents pending",
			count: 24,
			width: "76%",
			tone: "from-amber to-peach",
		},
		{ label: "Quotes sent", count: 36, width: "68%", tone: "from-sky to-mint" },
		{
			label: "Payment in progress",
			count: 11,
			width: "42%",
			tone: "from-mint to-sky",
		},
		{
			label: "Policies issued",
			count: 42,
			width: "58%",
			tone: "from-coral to-amber",
		},
	];

	const quickActions = [
		{ title: "Create quote", href: "/buy-now" },
		{ title: "Vehicle details", href: "/vehicle-details" },
		{ title: "Quote results", href: "/quotes" },
		{ title: "Today's callbacks", href: "#" },
	];

	const leadRows = [
		{
			customer: "Rohit Mehra",
			insurance: "Car Insurance",
			stage: "Quote Shared",
			statusTone: "bg-sky/18 text-sky-700",
			premium: "Rs 18,420",
			nextStep: "Call at 4:30 PM",
		},
		{
			customer: "Ananya Sharma",
			insurance: "Health Insurance",
			stage: "Documents Pending",
			statusTone: "bg-amber/18 text-amber-700",
			premium: "Rs 24,860",
			nextStep: "Waiting for KYC upload",
		},
		{
			customer: "Vikram Shetty",
			insurance: "Commercial Vehicle",
			stage: "Payment Follow-up",
			statusTone: "bg-peach/18 text-coral",
			premium: "Rs 31,275",
			nextStep: "Resend payment link",
		},
		{
			customer: "Nidhi Patel",
			insurance: "Life Insurance",
			stage: "Policy Issued",
			statusTone: "bg-mint/20 text-mint-700",
			premium: "Rs 15,940",
			nextStep: "Welcome call tomorrow",
		},
	];

	const followUps = [
		{
			time: "10:30 AM",
			title: "Renewal reminder",
			customer: "Suresh Kulkarni",
			type: "Bike Insurance",
		},
		{
			time: "12:15 PM",
			title: "Explain IDV options",
			customer: "Rakesh Jain",
			type: "Car Insurance",
		},
		{
			time: "03:00 PM",
			title: "Medical declaration",
			customer: "Sonal Verma",
			type: "Health Insurance",
		},
		{
			time: "05:45 PM",
			title: "Payment confirmation",
			customer: "Arjun Nair",
			type: "Term Insurance",
		},
	];

	const renewalRows = [
		{
			customer: "Pooja Nair",
			due: "14 May 2026",
			plan: "Car Insurance",
			amount: "Rs 17,880",
			priority: "High",
			mobile: "919876543210",
			email: "pooja.nair@example.com",
		},
		{
			customer: "Rahul Deshmukh",
			due: "16 May 2026",
			plan: "Health Insurance",
			amount: "Rs 21,460",
			priority: "Medium",
			mobile: "919812345678",
			email: "rahul.deshmukh@example.com",
		},
		{
			customer: "Karan Oberoi",
			due: "18 May 2026",
			plan: "Commercial Vehicle",
			amount: "Rs 28,300",
			priority: "High",
			mobile: "919945678123",
			email: "karan.oberoi@example.com",
		},
	];

	const claimRows = [
		{
			customer: "Deepa Joshi",
			claimId: "CLM-4021",
			insurer: "Digit",
			status: "Survey scheduled",
			tone: "bg-sky/18 text-sky-700",
		},
		{
			customer: "Akash Singh",
			claimId: "CLM-3988",
			insurer: "ICICI Lombard",
			status: "Document review",
			tone: "bg-amber/18 text-amber-700",
		},
		{
			customer: "Mehul Shah",
			claimId: "CLM-3944",
			insurer: "Zuno",
			status: "Approved",
			tone: "bg-mint/20 text-mint-700",
		},
	];

	const personalStats = [
		{
			label: "Issued this week",
			value: "14",
			note: "4 more than your last week",
			width: "70%",
		},
		{
			label: "Conversion rate",
			value: "32%",
			note: "Best line is car insurance",
			width: "32%",
		},
		{
			label: "Booked premium",
			value: "Rs 4.8L",
			note: "Across your issued policies",
			width: "82%",
		},
	];

	const weeklyTrend = [34, 58, 44, 72, 63, 84, 68];
	const premiumTrend = [
		"Rs 48k",
		"Rs 62k",
		"Rs 57k",
		"Rs 81k",
		"Rs 76k",
		"Rs 92k",
		"Rs 84k",
	];
	const productMix = [
		{ label: "Car", value: 46, tone: "bg-coral" },
		{ label: "Health", value: 24, tone: "bg-sky" },
		{ label: "Life", value: 18, tone: "bg-mint" },
		{ label: "Commercial", value: 12, tone: "bg-amber" },
	];
	const monthBars = [
		{ label: "Mon", value: 42 },
		{ label: "Tue", value: 58 },
		{ label: "Wed", value: 51 },
		{ label: "Thu", value: 75 },
		{ label: "Fri", value: 66 },
		{ label: "Sat", value: 82 },
		{ label: "Sun", value: 48 },
	];
	const insights = [
		"Your car renewals are converting 14% faster this week.",
		"Your health insurance leads from WhatsApp have the highest response rate.",
		"6 of your customers are waiting only for payment confirmation.",
	];

	const closeReminderModal = () => {
		setSelectedReminder(null);
		setReminderFeedback("");
		setIsSendingReminder(false);
		setIsSendingEmailReminder(false);
	};

	const handleWhatsappReminder = async () => {
		if (!selectedReminder || isSendingReminder) {
			return;
		}

		const payload = {
			customerName: selectedReminder.customer,
			mobileNumber: selectedReminder.mobile,
			email: selectedReminder.email,
			planName: selectedReminder.plan,
			renewalDueDate: selectedReminder.due,
			renewalAmount: selectedReminder.amount,
			channel: "WhatsApp",
			message: `Hello ${selectedReminder.customer}, your ${selectedReminder.plan} renewal of ${selectedReminder.amount} is due on ${selectedReminder.due}. Please connect with your CoverGrid agent to renew on time.`,
		};

		try {
			setIsSendingReminder(true);
			setReminderFeedback("");

			const response = await fetch(
				"https://demoo4s.com/api/Values/SendWhatsappMessage",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(payload),
				},
			);

			if (!response.ok) {
				throw new Error(`Request failed with status ${response.status}`);
			}

			setReminderFeedback("WhatsApp reminder sent successfully.");
		} catch (error) {
			setReminderFeedback("Unable to send WhatsApp reminder right now.");
		} finally {
			setIsSendingReminder(false);
		}
	};

	const handleEmailReminder = async () => {
		if (!selectedReminder || isSendingEmailReminder) {
			return;
		}

		const payload = {
			customerName: selectedReminder.customer,
			mobileNumber: selectedReminder.mobile,
			email: selectedReminder.email,
			planName: selectedReminder.plan,
			renewalDueDate: selectedReminder.due,
			renewalAmount: selectedReminder.amount,
			channel: "Email",
			subject: `${selectedReminder.plan} renewal reminder`,
			message: `Hello ${selectedReminder.customer}, your ${selectedReminder.plan} renewal of ${selectedReminder.amount} is due on ${selectedReminder.due}. Please connect with your CoverGrid agent to renew on time.`,
		};

		try {
			setIsSendingEmailReminder(true);
			setReminderFeedback("");

			const response = await fetch(
				"https://demoo4s.com/api/Values/SendEmail",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(payload),
				},
			);

			if (!response.ok) {
				throw new Error(`Request failed with status ${response.status}`);
			}

			setReminderFeedback("Email reminder sent successfully.");
		} catch (error) {
			setReminderFeedback("Unable to send email reminder right now.");
		} finally {
			setIsSendingEmailReminder(false);
		}
	};

	return (
		<div className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top_left,rgba(255,123,84,0.18),transparent_24%),radial-gradient(circle_at_85%_18%,rgba(121,189,232,0.16),transparent_18%),radial-gradient(circle_at_bottom_left,rgba(99,199,171,0.16),transparent_24%),linear-gradient(180deg,#fff8f0_0%,#f6fbff_52%,#eefaf7_100%)] px-4 py-5 text-ink md:px-8">
			<div className="pointer-events-none absolute inset-0 opacity-70">
				<div className="absolute left-0 top-16 h-56 w-56 rounded-full bg-peach/16 blur-3xl"></div>
				<div className="absolute right-10 top-20 h-48 w-48 rounded-full bg-sky/18 blur-3xl"></div>
				<div className="absolute bottom-8 left-1/3 h-56 w-56 rounded-full bg-mint/20 blur-3xl"></div>
			</div>

			<div className="relative mx-auto max-w-[1480px]">
				<header className="rounded-[30px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,248,242,0.95)_0%,rgba(255,255,255,0.92)_100%)] px-5 py-5 shadow-[0_24px_50px_rgba(43,74,107,0.10)] backdrop-blur-sm md:px-7">
					<div className="grid gap-5 xl:grid-cols-[1.2fr_0.8fr] xl:items-center">
						<div className="flex flex-wrap items-center gap-4">
							<div className="grid h-16 w-16 place-items-center rounded-[22px] bg-gradient-to-br from-peach to-coral text-xl font-extrabold text-white shadow-[0_14px_30px_rgba(225,95,56,0.22)]">
								SP
							</div>
							<div>
								<p className="text-xs font-bold uppercase tracking-[0.18em] text-coral">
									My agent workspace
								</p>
								<h1 className="mt-1 font-display text-4xl font-bold tracking-[-0.05em] text-ink">
									Shyam Panda Dashboard
								</h1>
								<p className="mt-2 text-sm text-slate-500">
									Track your leads, quotes, renewals, claims, and daily
									follow-ups from one place.
								</p>
							</div>
						</div>

						<div className="grid gap-3 sm:grid-cols-2">
							<div className="rounded-[24px] border border-white/80 bg-white/82 p-4 shadow-[0_10px_20px_rgba(43,74,107,0.05)]">
								<div className="flex items-center justify-between gap-4">
									<div>
										<p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
											Today's premium
										</p>
										<p className="mt-2 text-2xl font-bold text-coral">
											Rs 1,84,260
										</p>
										<p className="mt-1 text-sm text-slate-500">
											7 cases moved today
										</p>
									</div>
									<div
										className="grid h-20 w-20 place-items-center rounded-full"
										style={{
											background:
												"conic-gradient(#ff7b54 0 72%, rgba(255,123,84,0.14) 72% 100%)",
										}}
									>
										<div className="grid h-14 w-14 place-items-center rounded-full bg-white text-sm font-bold text-coral">
											72%
										</div>
									</div>
								</div>
							</div>
							<div className="rounded-[24px] border border-white/80 bg-white/82 p-4 shadow-[0_10px_20px_rgba(43,74,107,0.05)]">
								<p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
									Weekly premium trend
								</p>
								<div className="mt-4 flex h-20 items-end gap-2">
									{weeklyTrend.map((value, index) => (
										<div
											key={premiumTrend[index]}
											className="flex flex-1 flex-col items-center gap-2"
										>
											<div
												className="w-full rounded-t-[10px] bg-gradient-to-t from-peach to-coral"
												style={{ height: `${value}%` }}
											></div>
										</div>
									))}
								</div>
								<div className="mt-3 grid grid-cols-7 gap-2 text-[11px] font-semibold text-slate-400">
									{["M", "T", "W", "T", "F", "S", "S"].map((day) => (
										<span key={day} className="text-center">
											{day}
										</span>
									))}
								</div>
							</div>
						</div>
					</div>
				</header>

				<section className="mt-5 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
					{summaryCards.map((card) => (
						<article
							key={card.label}
							className="rounded-[26px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.94)_0%,rgba(248,252,255,0.95)_100%)] p-5 shadow-[0_18px_38px_rgba(43,74,107,0.08)]"
						>
							<div
								className={`inline-flex rounded-full bg-gradient-to-r ${card.accent} px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-white`}
							>
								{card.label}
							</div>
							<p className="mt-4 font-display text-4xl font-bold tracking-[-0.05em] text-ink">
								{card.value}
							</p>
							<div className="mt-3 h-2 rounded-full bg-slate-100">
								<div
									className={`h-2 rounded-full bg-gradient-to-r ${card.accent}`}
									style={{ width: card.progress }}
								></div>
							</div>
							<p className="mt-3 text-sm font-medium text-slate-500">
								{card.note}
							</p>
						</article>
					))}
				</section>

				<section className="mt-5 grid gap-5 xl:grid-cols-[1.15fr_0.85fr]">
					<div className="space-y-5">
						<article className="rounded-[30px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,251,247,0.94)_0%,rgba(255,255,255,0.95)_100%)] p-5 shadow-[0_22px_44px_rgba(43,74,107,0.08)]">
							<div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
								<div>
									<p className="text-xs font-bold uppercase tracking-[0.18em] text-coral">
										My pipeline
									</p>
									<h2 className="mt-2 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
										Lead movement
									</h2>
								</div>
								<div className="flex flex-wrap gap-3">
									{quickActions.map((action) => (
										<a
											key={action.title}
											href={action.href}
											className="rounded-full border border-white/80 bg-white/86 px-4 py-2 text-sm font-semibold text-slate-600 shadow-[0_10px_20px_rgba(43,74,107,0.05)] transition hover:-translate-y-0.5 hover:text-coral"
										>
											{action.title}
										</a>
									))}
								</div>
							</div>

							<div className="mt-6 grid gap-4 lg:grid-cols-[1fr_0.95fr]">
								<div className="rounded-[24px] border border-white/80 bg-white/82 p-4 shadow-[0_12px_26px_rgba(43,74,107,0.05)]">
									<div className="flex items-center justify-between">
										<h3 className="text-lg font-bold text-slate-700">Funnel</h3>
										<span className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
											This week
										</span>
									</div>
									<div className="mt-5 space-y-4">
										{funnelSteps.map((step) => (
											<div key={step.label}>
												<div className="mb-2 flex items-center justify-between text-sm font-semibold text-slate-600">
													<span>{step.label}</span>
													<span className="text-ink">{step.count}</span>
												</div>
												<div className="h-10 rounded-[14px] bg-slate-100 p-1">
													<div
														className={`flex h-full items-center rounded-[12px] bg-gradient-to-r ${step.tone} px-4 text-sm font-bold text-white`}
														style={{ width: step.width }}
													>
														{step.count}
													</div>
												</div>
											</div>
										))}
									</div>
								</div>

								<div className="rounded-[24px] border border-white/80 bg-white/82 p-4 shadow-[0_12px_26px_rgba(43,74,107,0.05)]">
									<div className="flex items-center justify-between">
										<h3 className="text-lg font-bold text-slate-700">
											Premium trend
										</h3>
										<span className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
											Last 7 days
										</span>
									</div>
									<div className="mt-5 flex h-52 items-end gap-3">
										{monthBars.map((bar, index) => (
											<div
												key={bar.label}
												className="flex flex-1 flex-col items-center gap-2"
											>
												<span className="text-[11px] font-semibold text-slate-400">
													{premiumTrend[index]}
												</span>
												<div
													className="w-full rounded-t-[14px] bg-gradient-to-t from-sky to-mint"
													style={{ height: `${bar.value}%` }}
												></div>
												<span className="text-xs font-bold uppercase tracking-[0.12em] text-slate-400">
													{bar.label}
												</span>
											</div>
										))}
									</div>
								</div>
							</div>

							<div className="mt-6 rounded-[24px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.92)_0%,rgba(246,250,255,0.96)_100%)] p-4 shadow-[0_12px_28px_rgba(43,74,107,0.06)]">
								<div className="flex items-center justify-between gap-3">
									<div>
										<h3 className="text-xl font-bold text-slate-700">
											My recent leads
										</h3>
										<p className="mt-1 text-sm text-slate-500">
											Track customers and their current stage.
										</p>
									</div>
									<span className="rounded-full bg-peach/12 px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-coral">
										Live
									</span>
								</div>

								<div className="mt-4 overflow-hidden rounded-[20px] border border-slate-100">
									<div className="grid grid-cols-[1.1fr_1fr_0.9fr_0.85fr_1fr] gap-3 bg-slate-50 px-4 py-3 text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
										<span>Customer</span>
										<span>Policy</span>
										<span>Stage</span>
										<span>Premium</span>
										<span>Next step</span>
									</div>
									{leadRows.map((row) => (
										<div
											key={`${row.customer}-${row.stage}`}
											className="grid grid-cols-[1.1fr_1fr_0.9fr_0.85fr_1fr] gap-3 border-t border-slate-100 bg-white/90 px-4 py-4 text-sm text-slate-600"
										>
											<span className="font-semibold text-ink">
												{row.customer}
											</span>
											<span>{row.insurance}</span>
											<span>
												<span
													className={`rounded-full px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] ${row.statusTone}`}
												>
													{row.stage}
												</span>
											</span>
											<span className="font-semibold text-ink">
												{row.premium}
											</span>
											<span>{row.nextStep}</span>
										</div>
									))}
								</div>
							</div>
						</article>

						<article className="rounded-[30px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.94)_0%,rgba(246,251,255,0.96)_100%)] p-5 shadow-[0_22px_44px_rgba(43,74,107,0.08)]">
							<div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
								<div>
									<p className="text-xs font-bold uppercase tracking-[0.18em] text-coral">
										My retention desk
									</p>
									<h2 className="mt-2 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
										Renewals and claims
									</h2>
								</div>
								<div className="rounded-full border border-white/80 bg-white/80 px-4 py-2 text-sm font-semibold text-slate-600 shadow-[0_10px_20px_rgba(43,74,107,0.05)]">
									87% of your service SLA on time
								</div>
							</div>

							<div className="mt-6 grid gap-4 lg:grid-cols-2">
								<div className="rounded-[24px] border border-white/80 bg-white/82 p-4 shadow-[0_10px_22px_rgba(43,74,107,0.05)]">
									<h3 className="text-xl font-bold text-slate-700">
										My upcoming renewals
									</h3>
									<div className="mt-4 space-y-3">
										{renewalRows.map((row) => (
											<div
												key={`${row.customer}-${row.due}`}
												className="rounded-[18px] border border-slate-100 bg-slate-50/90 p-4"
											>
												<div className="flex items-start justify-between gap-4">
													<div>
														<p className="font-semibold text-ink">
															{row.customer}
														</p>
														<p className="mt-1 text-sm text-slate-500">
															{row.plan}
														</p>
													</div>
													<span
														className={`rounded-full px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] ${row.priority === "High" ? "bg-coral/12 text-coral" : "bg-amber/18 text-amber-700"}`}
													>
														{row.priority}
													</span>
												</div>
												<div className="mt-3 flex items-center justify-between text-sm text-slate-500">
													<span>Due {row.due}</span>
													<div className="flex items-center gap-3">
														<span className="font-semibold text-ink">
															{row.amount}
														</span>
														<button
															type="button"
															onClick={() => setSelectedReminder(row)}
															className="rounded-full bg-gradient-to-r from-peach to-coral px-3 py-2 text-xs font-bold uppercase tracking-[0.12em] text-white shadow-[0_10px_20px_rgba(225,95,56,0.16)] transition hover:-translate-y-0.5"
														>
															Remind Now
														</button>
													</div>
												</div>
											</div>
										))}
									</div>
								</div>

								<div className="rounded-[24px] border border-white/80 bg-white/82 p-4 shadow-[0_10px_22px_rgba(43,74,107,0.05)]">
									<h3 className="text-xl font-bold text-slate-700">
										My claim monitor
									</h3>
									<div className="mt-4 space-y-3">
										{claimRows.map((row) => (
											<div
												key={row.claimId}
												className="rounded-[18px] border border-slate-100 bg-slate-50/90 p-4"
											>
												<div className="flex items-start justify-between gap-4">
													<div>
														<p className="font-semibold text-ink">
															{row.customer}
														</p>
														<p className="mt-1 text-sm text-slate-500">
															{row.claimId} • {row.insurer}
														</p>
													</div>
													<span
														className={`rounded-full px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] ${row.tone}`}
													>
														{row.status}
													</span>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</article>
					</div>

					<div className="space-y-5">
						<article className="rounded-[30px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,246,240,0.95)_0%,rgba(255,255,255,0.94)_100%)] p-5 shadow-[0_22px_44px_rgba(43,74,107,0.08)]">
							<p className="text-xs font-bold uppercase tracking-[0.18em] text-coral">
								My productivity
							</p>
							<h2 className="mt-2 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
								Personal performance
							</h2>

							<div className="mt-5 rounded-[24px] border border-white/80 bg-white/84 p-5 shadow-[0_10px_22px_rgba(43,74,107,0.05)]">
								<div className="flex items-center justify-between gap-4">
									<div>
										<p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
											Portfolio mix
										</p>
										<p className="mt-2 text-2xl font-bold text-ink">
											Where your business is coming from
										</p>
									</div>
									<div
										className="h-28 w-28 rounded-full"
										style={{
											background:
												"conic-gradient(#ff7b54 0 46%, #7ec8e3 46% 70%, #63c7ab 70% 88%, #f0b247 88% 100%)",
										}}
									>
										<div className="m-[18px] grid h-[76px] w-[76px] place-items-center rounded-full bg-white text-sm font-bold text-ink">
											Mix
										</div>
									</div>
								</div>

								<div className="mt-5 space-y-3">
									{productMix.map((item) => (
										<div key={item.label}>
											<div className="mb-2 flex items-center justify-between text-sm font-semibold text-slate-600">
												<span>{item.label}</span>
												<span>{item.value}%</span>
											</div>
											<div className="h-2 rounded-full bg-slate-100">
												<div
													className={`h-2 rounded-full ${item.tone}`}
													style={{ width: `${item.value}%` }}
												></div>
											</div>
										</div>
									))}
								</div>
							</div>

							<div className="mt-4 space-y-3">
								{personalStats.map((stat) => (
									<div
										key={stat.label}
										className="rounded-[22px] border border-white/80 bg-white/84 p-4 shadow-[0_10px_22px_rgba(43,74,107,0.05)]"
									>
										<div className="flex items-start justify-between gap-4">
											<div>
												<p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
													{stat.label}
												</p>
												<p className="mt-2 text-2xl font-bold text-ink">
													{stat.value}
												</p>
											</div>
											<span className="rounded-full bg-mint/18 px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] text-mint-700">
												My book
											</span>
										</div>
										<div className="mt-4 h-2 rounded-full bg-slate-100">
											<div
												className="h-2 rounded-full bg-gradient-to-r from-peach to-coral"
												style={{ width: stat.width }}
											></div>
										</div>
										<p className="mt-3 text-sm font-semibold text-slate-600">
											{stat.note}
										</p>
									</div>
								))}
							</div>
						</article>

						<article className="rounded-[30px] border border-white/80 bg-[linear-gradient(180deg,rgba(246,251,255,0.95)_0%,rgba(255,255,255,0.94)_100%)] p-5 shadow-[0_22px_44px_rgba(43,74,107,0.08)]">
							<p className="text-xs font-bold uppercase tracking-[0.18em] text-coral">
								My business snapshot
							</p>
							<h2 className="mt-2 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
								Smart insights
							</h2>
							<div className="mt-5 space-y-3">
								{insights.map((insight) => (
									<div
										key={insight}
										className="rounded-[20px] border border-white/80 bg-white/84 px-4 py-4 text-sm leading-6 text-slate-600 shadow-[0_10px_22px_rgba(43,74,107,0.05)]"
									>
										{insight}
									</div>
								))}
							</div>

							<div className="mt-5 grid gap-3 sm:grid-cols-2">
								<div className="rounded-[20px] border border-peach/18 bg-peach/8 px-4 py-4">
									<p className="text-xs font-bold uppercase tracking-[0.14em] text-coral">
										Persistency
									</p>
									<p className="mt-2 text-3xl font-bold text-ink">91%</p>
									<p className="mt-1 text-sm text-slate-500">
										Your 12-month active customer retention.
									</p>
								</div>
								<div className="rounded-[20px] border border-mint/20 bg-mint/10 px-4 py-4">
									<p className="text-xs font-bold uppercase tracking-[0.14em] text-mint-700">
										Commission
									</p>
									<p className="mt-2 text-3xl font-bold text-ink">Rs 2.84L</p>
									<p className="mt-1 text-sm text-slate-500">
										Your projected earnings for the current month.
									</p>
								</div>
							</div>

							<div className="mt-5 rounded-[24px] border border-white/80 bg-white/84 p-4 shadow-[0_10px_22px_rgba(43,74,107,0.05)]">
								<div className="flex items-center justify-between">
									<p className="text-sm font-bold text-slate-700">
										Today's follow-ups
									</p>
									<span className="text-xs font-bold uppercase tracking-[0.12em] text-slate-400">
										4 tasks
									</span>
								</div>
								<div className="mt-4 space-y-3">
									{followUps.map((item) => (
										<div
											key={`${item.time}-${item.customer}`}
											className="flex items-start gap-3"
										>
											<span className="mt-1 rounded-full bg-coral/10 px-2 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-coral">
												{item.time}
											</span>
											<div>
												<p className="text-sm font-semibold text-ink">
													{item.title}
												</p>
												<p className="text-sm text-slate-500">
													{item.customer} • {item.type}
												</p>
											</div>
										</div>
									))}
								</div>
							</div>
						</article>
					</div>
				</section>
			</div>

			{selectedReminder ? (
				<div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(20,48,74,0.18)] px-4 backdrop-blur-sm">
					<div className="w-full max-w-md rounded-[28px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,248,242,0.98)_0%,rgba(255,255,255,0.98)_100%)] p-6 shadow-[0_26px_60px_rgba(43,74,107,0.16)]">
						<div className="flex items-start justify-between gap-4">
							<div>
								<p className="text-xs font-bold uppercase tracking-[0.18em] text-coral">
									Renewal Reminder
								</p>
								<h3 className="mt-2 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
									{selectedReminder.customer}
								</h3>
								<p className="mt-2 text-sm text-slate-500">
									Choose how you want to send the reminder for{" "}
									{selectedReminder.plan}.
								</p>
							</div>
							<button
								type="button"
								onClick={closeReminderModal}
								className="grid h-10 w-10 place-items-center rounded-full border border-white/90 bg-white text-xl text-slate-400 shadow-[0_10px_22px_rgba(53,85,130,0.08)] transition hover:-translate-y-0.5 hover:text-ink"
							>
								x
							</button>
						</div>

						<div className="mt-5 grid gap-3 sm:grid-cols-2">
							<button
								type="button"
								onClick={handleWhatsappReminder}
								disabled={isSendingReminder}
								className="rounded-[22px] border border-mint/25 bg-[linear-gradient(180deg,rgba(99,199,171,0.12)_0%,rgba(255,255,255,0.96)_100%)] px-4 py-5 text-left shadow-[0_12px_24px_rgba(43,74,107,0.06)] transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60"
							>
								<p className="text-xs font-bold uppercase tracking-[0.14em] text-mint-700">
									WhatsApp
								</p>
								<p className="mt-2 text-lg font-bold text-ink">
									{isSendingReminder ? "Sending..." : "Send on WhatsApp"}
								</p>
								<p className="mt-1 text-sm text-slate-500">
									Quick reminder with payment or quote follow-up.
								</p>
							</button>

							<button
								type="button"
								onClick={handleEmailReminder}
								disabled={isSendingEmailReminder}
								className="rounded-[22px] border border-sky/25 bg-[linear-gradient(180deg,rgba(121,189,232,0.12)_0%,rgba(255,255,255,0.96)_100%)] px-4 py-5 text-left shadow-[0_12px_24px_rgba(43,74,107,0.06)] transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60"
							>
								<p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700">
									Email
								</p>
								<p className="mt-2 text-lg font-bold text-ink">
									{isSendingEmailReminder ? "Sending..." : "Send by Email"}
								</p>
								<p className="mt-1 text-sm text-slate-500">
									Share a formal renewal reminder with details.
								</p>
							</button>
						</div>

						{reminderFeedback ? (
							<div className="mt-4 rounded-[18px] border border-white/80 bg-white/86 px-4 py-3 text-sm font-semibold text-slate-600 shadow-[0_10px_22px_rgba(43,74,107,0.05)]">
								{reminderFeedback}
							</div>
						) : null}
					</div>
				</div>
			) : null}
		</div>
	);
}

window.AppPages = window.AppPages || {};
window.AppPages.AgentDashboardPage = AgentDashboardPage;
